/* eslint-disable */
// THIS FILE IS AUTO-GENERATED
const versionInfo = {
    "git": true,
    "SHA": "333f52365066b33256e6ade515c477fae90e969c",
    "shortSHA": "333f523",
    "date": "2020-05-11T03:37:49+0000",
    "apiVersion": "2.5.0"
};
export default versionInfo;



// WEBPACK FOOTER //
// ./clients/web/src/version.js